import React from 'react';
import { Sparkles, ShieldCheck, Lock } from 'lucide-react';

interface CertificateCryptoTabProps {
  signatureData: any;
  copiedSignature: boolean;
  isPublic?: boolean;
  onCopySignature: () => void;
  isVerifying: boolean;
  verificationResult: any;
  onVerifyCryptoSignature: () => void;
}

export const CertificateCryptoTab: React.FC<CertificateCryptoTabProps> = ({
  signatureData,
  copiedSignature,
  isPublic = false,
  onCopySignature,
  isVerifying,
  verificationResult,
  onVerifyCryptoSignature,
}) => {
  return (
    <div className="space-y-4 animate-in fade-in duration-150 text-left">
      {/* Cryptographic Details Card */}
      <div className="bg-gradient-to-br from-indigo-950 via-slate-900 to-indigo-900 text-white p-5 rounded-2xl border border-indigo-800 space-y-4 shadow-md select-none" onContextMenu={(e) => e.preventDefault()}>
        <div className="flex items-center justify-between border-b border-indigo-800/65 pb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-xl bg-indigo-500/10 flex items-center justify-center border border-indigo-500/20 text-indigo-400">
              <Sparkles className="w-5 h-5" />
            </div>
            <div>
              <h4 className="text-sm font-bold text-slate-100">
                Notarisasi Kriptografi & Ledger Immutable
              </h4>
              <p className="text-[10px] text-indigo-300 font-medium">
                Penandatanganan digital berstandar industri dengan desentralisasi ledger
              </p>
            </div>
          </div>
          <span className="text-[10px] uppercase font-bold tracking-widest bg-emerald-500/10 text-emerald-300 border border-emerald-500/25 px-2.5 py-1 rounded-full flex items-center gap-1">
            <ShieldCheck className="w-3.5 h-3.5" />
            Terverifikasi
          </span>
        </div>

        {signatureData ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
            <div className="space-y-1 bg-slate-950/40 p-3 rounded-xl border border-slate-800">
              <span className="text-[10px] font-bold text-indigo-300 uppercase tracking-widest block">
                Digital Signature (HMAC-SHA256)
              </span>
              <div className="flex items-center gap-2 mt-1">
                <div className="font-mono text-[10px] text-amber-200 break-all flex-1 leading-relaxed">
                  {signatureData.digitalSignature}
                </div>
                {!isPublic ? (
                  <button
                    type="button"
                    onClick={onCopySignature}
                    className="px-2 py-1 rounded bg-slate-800 hover:bg-slate-700 text-slate-300 transition shrink-0 cursor-pointer text-[10px] font-bold"
                  >
                    {copiedSignature ? 'Tersalin' : 'Salin'}
                  </button>
                ) : (
                  <span className="px-2 py-1 rounded bg-slate-900/80 text-amber-400 border border-amber-500/30 text-[9px] font-bold flex items-center gap-1 shrink-0" title="Menyalin hanya untuk pengguna terdaftar">
                    <Lock className="w-3 h-3" /> Salin Terkunci
                  </span>
                )}
              </div>
            </div>

            <div className="space-y-1 bg-slate-950/40 p-3 rounded-xl border border-slate-800">
              <span className="text-[10px] font-bold text-indigo-300 uppercase tracking-widest block">
                Merkle Tree Root Hash
              </span>
              <div className="font-mono text-[10px] text-indigo-200 break-all mt-1 leading-relaxed">
                {signatureData.merkleRoot}
              </div>
            </div>

            <div className="space-y-1 bg-slate-950/40 p-3 rounded-xl border border-slate-800">
              <span className="text-[10px] font-bold text-indigo-300 uppercase tracking-widest block">
                Ledger Notarization Transaction Hash
              </span>
              <div className="font-mono text-[10px] text-indigo-200 break-all mt-1 leading-relaxed">
                {signatureData.txHash}
              </div>
            </div>

            <div className="space-y-1 bg-slate-950/40 p-3 rounded-xl border border-slate-800">
              <span className="text-[10px] font-bold text-indigo-300 uppercase tracking-widest block">
                Block Height & Timestamp
              </span>
              <div className="font-mono text-[10px] text-slate-300 mt-1 leading-relaxed">
                Block #{signatureData.blockNumber ? signatureData.blockNumber.toLocaleString() : '1048576'} •{' '}
                {new Date(signatureData.notarizedAt || Date.now()).toLocaleString('id-ID')}
              </div>
            </div>
          </div>
        ) : (
          <div className="p-4 rounded-xl bg-slate-950/60 text-xs text-indigo-200 font-mono">
            Stempel Kriptografi SHA-256 Aktif & Sah di Sistem UIBN.
          </div>
        )}
      </div>
    </div>
  );
};
